module.exports = "/assets/scripts/apps/overlays/1.11/img/check.svg";